"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationDetailModal = void 0;
var ApplicationDetailModal_1 = require("./ApplicationDetailModal");
Object.defineProperty(exports, "ApplicationDetailModal", { enumerable: true, get: function () { return ApplicationDetailModal_1.ApplicationDetailModal; } });
